import { render, staticRenderFns } from "./salesSolutions.vue?vue&type=template&id=4bea60e6"
import script from "./salesSolutions.vue?vue&type=script&lang=js"
export * from "./salesSolutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports